import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Workbench {

    export var QtyStatistics = (query: any): Promise<any> => {
        return Get(`/csp/Workbench/QtyStatistics?${qs.stringify(query)}`, {});
    };

    export var FYOrderQtyStatistics = (query: any): Promise<any> => {
        return Get(`/csp/Workbench/FYOrderQtyStatistics?${qs.stringify(query)}`, {});
    };


}

